import { render, staticRenderFns } from "./batchImport.vue?vue&type=template&id=a95d4c8e&scoped=true"
import script from "./batchImport.vue?vue&type=script&lang=js"
export * from "./batchImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95d4c8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a95d4c8e')) {
      api.createRecord('a95d4c8e', component.options)
    } else {
      api.reload('a95d4c8e', component.options)
    }
    module.hot.accept("./batchImport.vue?vue&type=template&id=a95d4c8e&scoped=true", function () {
      api.rerender('a95d4c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fixDutyFine/LMLiabilityForLosses/cmp/batchImport.vue"
export default component.exports